/* tslint:disable */
/* eslint-disable */
/**
 * Payment App-Tier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentEntryType = {
    Initiate: 'INITIATE',
    Auth: 'AUTH',
    Capture: 'CAPTURE',
    Cancel: 'CANCEL',
    Void: 'VOID',
    Skip: 'SKIP',
    InitiateRefund: 'INITIATE_REFUND',
    Refund: 'REFUND',
    RefundStandalone: 'REFUND_STANDALONE',
    RefundFollowOn: 'REFUND_FOLLOW_ON',
    Tokenize: 'TOKENIZE'
} as const;
export type PaymentEntryType = typeof PaymentEntryType[keyof typeof PaymentEntryType];


export function PaymentEntryTypeFromJSON(json: any): PaymentEntryType {
    return PaymentEntryTypeFromJSONTyped(json, false);
}

export function PaymentEntryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentEntryType {
    return json as PaymentEntryType;
}

export function PaymentEntryTypeToJSON(value?: PaymentEntryType | null): any {
    return value as any;
}

